export default __webpack_public_path__ + "static/media/plane.6eb9dff2.webp";